import styles from './index.module.scss';

export default function Pagination({ current, total, pageSize, onChange }: any) {
    const totalPages = Math.ceil(total / pageSize);

    const handlePageChange = (page: number) => {
        if (page >= 1 && page <= totalPages && page !== current) {
            onChange?.(page);
        }
    };

    const handlePrev = () => {
        handlePageChange(current - 1);
    };

    const handleNext = () => {
        handlePageChange(current + 1);
    };

    const isFirstPage = current <= 1;
    const isLastPage = current >= totalPages;

    return (
        <div className={styles.paginationBox}>
            <div className="paginationContainer">
                <div
                    className={`paginationPrev ${isFirstPage ? 'disabled' : ''}`}
                    onClick={handlePrev}
                    style={{
                        cursor: isFirstPage ? 'not-allowed' : 'pointer',
                        opacity: isFirstPage ? 0.4 : 1,
                    }}
                >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12.6668 8.00001H3.3335M3.3335 8.00001L8.00016 12.6667M3.3335 8.00001L8.00016 3.33334"
                            stroke="#1E1E1E"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
                <div className="paginationList">
                    <span className="paginationItem">{current}</span>
                    <span className="paginationItemOther">of {totalPages}</span>
                </div>
                <div
                    className={`paginationNext ${isLastPage ? 'disabled' : ''}`}
                    onClick={handleNext}
                    style={{
                        cursor: isLastPage ? 'not-allowed' : 'pointer',
                        opacity: isLastPage ? 0.4 : 1,
                    }}
                >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M3.3335 8.00001H12.6668M12.6668 8.00001L8.00016 3.33334M12.6668 8.00001L8.00016 12.6667"
                            stroke="#1E1E1E"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>
        </div>
    );
}
